// @ts-nocheck
import React, { useEffect, useState } from 'react';
import MobligoLogo from '../assets/img/mobligo_new.png';
import MyInput from '../components/ui/MyInput';
import PrimaryButton from '../components/ui/PrimaryButton';
import CreateAction from '../components/operational/createAction';
import { useDispatch } from 'react-redux';
import myUserSlice from '../redux/myUserSlice';
import { ReactComponent as AppleLogo } from '../assets/img/apple.svg';
import { ReactComponent as GoogleLogo } from '../assets/img/google.svg';
import { useGoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
const LoginComponent = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isError, setIsError] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLoginPress = async event => {
    if (event.key === 'Enter') {
      await handleLoginClickButton();
    }
  };

  const handleLoginClickButton = async () => {
    const response = await CreateAction({
      method: 'post',
      path: '/sso/login',
      data: { email, password },
      showPreLoader: true,
      isFileUploading: false,
    });

    if (response?.error) return setIsError(true);
    setUserInformation(response);
    window.location.href = '/chooseApp';
  };

  const setUserInformation = response => {
    const token = response.result.resultData.token;
    const refreshToken = response.result.resultData.refreshToken;
    const user = response.result.resultData.user;
    if (!user || !token) return null;

    localStorage.setItem('token', token);
    localStorage.setItem('refreshToken', refreshToken);

    dispatch(myUserSlice.actions.setUser(user));
  };

  const handleSocialLogin = async tokenResponse => {
    const response = await CreateAction({
      method: 'post',
      path: '/sso/socialLogin',
      data: { email, password },
      showPreLoader: true,
      isFileUploading: false,
      data: {
        token: tokenResponse?.access_token,
      },
    });

    if (response?.error) return setIsError(true);

    setUserInformation(response);
    window.location.href = '/chooseApp';
  };

  const loginWithGoogle = useGoogleLogin({
    onSuccess: tokenResponse => handleSocialLogin(tokenResponse),
    onError: tokenResponse => console.log(tokenResponse),
  });

  return (
    <>
      <p className="text-[#2C2C2C] font-medium text-3xl">Uygulamanıza giriş yapın</p>
      <p className="text-[#8A92A6] font-medium text-sm">mobligo’ya devam edin.</p>

      <div className="w-[300px] sm:w-[500px] mt-7 gap-3 flex flex-col">
        <MyInput
          label={'E-Posta Adresi'}
          isError={isError}
          type="text"
          color="black"
          onKeyDown={handleLoginPress}
          classes="bg-transparent z-20 h-14"
          onChange={(e: any) => {
            setEmail(e);
            setIsError(false);
          }}
          placeholder="E-posta"
          value={email}
        ></MyInput>
        <div>
          <p className="block mb-2 text-sm font-medium text-gray-900 text-stale-400 ">Şifre</p>
          <MyInput
            isError={isError}
            type="password"
            color="black"
            onKeyDown={handleLoginPress}
            onChange={(e: any) => setPassword(e)}
            classes="bg-transparent h-14"
            placeholder="Parola"
            value={password}
          ></MyInput>
        </div>

        {isError && (
          <div className="flex  items-start">
            <p className="text-[#C5000B] text-sm px-1">
              Lütfen hesap adınızı ve parolanızı kontrol edip tekrar deneyin.
            </p>
          </div>
        )}
        <div>
          <span
            style={{ textDecoration: 'none', cursor: 'pointer' }}
            className="text-sm font-medium text-[#8A92A6] mt-1 px-1 dark:text-slate-200 hover:text-[#6F66F6] w-full text-start"
            onClick={(e: any) => {
              navigate('/forgotPassword');
            }}
          >
            Şifrenizi mi unuttunuz?
          </span>
        </div>
        <PrimaryButton
          classes={'py-4 my-2 rounded h-14 bg-[#6F66F6] transition duration-150'}
          loading={false}
          onClick={handleLoginClickButton}
          value="Giriş Yap"
        />
        <div className="relative">
          <div className="relative flex justify-center">
            <span className="bg-white text-sm mb-2 font-normal text-[#8A92A6]">ya da</span>
          </div>
        </div>
      </div>
      <div className="w-[300px] sm:w-[500px]">
        <button
          type="button"
          className="py-4 bg-[#fffff] flex rounded h-14 border border-slate w-full justify-center items-center hover:bg-[#E3E8EF] transition duration-150 "
          onClick={() => loginWithGoogle()}
        >
          <GoogleLogo className="h-6 w-6 mr-2" />
          <span className="font-bold">Google ile giriş yap</span>
        </button>
      </div>
      {/* <div className="w-[300px] sm:w-[500px]">
              <button className="py-2 my-2 bg-[#fffff] flex rounded-full h-14 border border-slate w-full justify-center items-center hover:bg-[#E3E8EF] transition duration-150 ">
                <AppleLogo className="h-6 w-6 mr-2" />
                <span className="font-bold">Apple ile giriş yap</span>
              </button>
            </div> */}
      <div className="flex flex-row text-center justify-center gap-2 items-center mt-4">
        <p className="text-[#8A92A6]">Hesabınız yok mu? </p>
        <span
          className="text-md font-medium dark:text-slate-200 text-[#6f66f6] cursor-pointer"
          onClick={(e: any) => {
            navigate('/register');
          }}
        >
          Kayıt Ol
        </span>
      </div>
    </>
  );
};

export default LoginComponent;
